// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__4DBQK","content":"content__bWSw-"};